import React from 'react'
import _ from 'underscore'
import { IssueType } from '../../domain/Error'
import LegacyNavigatorWrapper from '../../helper/legacyNavigatorWrapper'
import Link from '../../helper/link'

interface Props {
    level: IssueType
    selectedStatus: number
    navigator: LegacyNavigatorWrapper
}

class StatusSelector extends React.Component<Props> {
    public static displayName = 'StatusSelector'

    public render() {
        const statusMap = this.getStatusMapByLevel()

        return (
            <div
                className="dropdown"
                style={{ paddingLeft: '8px', float: 'left' }}
                data-field="status"
                data-value={this.props.selectedStatus}
            >
                <button className="dropdown-toggle btn btn-default" data-toggle="dropdown">
                    Status: <span>{statusMap[this.props.selectedStatus]}</span>
                    <b className="caret" />
                </button>
                <ul className="dropdown-menu" role="menu" style={{ left: '0', right: 'auto' }}>
                    {_.map(statusMap, (text, dataValue) => {
                        return (
                            <li key={dataValue}>
                                <Link
                                    key={dataValue}
                                    {...this.props.navigator.linkTo({ status: dataValue, page: 1 })}
                                    data-value={dataValue}
                                >
                                    {text}
                                </Link>
                            </li>
                        )
                    })}
                </ul>
            </div>
        )
    }

    private getStatusMapByLevel() {
        if (this.props.level === IssueType.ERROR || this.props.level === IssueType.SLOWSQL) {
            return {
                0: 'All',
                1: 'Open',
                2: 'Resolved',
                4: 'Ignored',
            }
        }

        if (this.props.level === IssueType.OBSERVATION) {
            return {
                0: 'All',
                1: 'Open',
                2: 'Ignored',
            }
        }

        return {
            0: 'All',
            1: 'Open',
            2: 'Resolved',
        }
    }
}

export default StatusSelector
